import './campaigns.controller.scss'
import {CampaignService} from "../../campaigns_service/service/CampaignService";
import {CampaignServiceName, ToastNotificationServiceName} from "../../utils/names/serviceNames";
import {CampaignToggle} from "../../campaigns_service/model/CampaignToggle";
import {ToastNotificationService} from "../../utils/ToastNotificationService";

export class CampaignsController {
    static instance = [
        'campaignConfigs',
        'campaignLeadConfigs',
        'campaignPartnerConfigs',
        'campaignLoanOfficerConfigs',
        CampaignServiceName,
        ToastNotificationServiceName,
        CampaignsController
    ];

    constructor(private campaignToggles: CampaignToggle[],
                private campaignLeadConfigs: CampaignToggle[],
                private campaignPartnerConfigs: CampaignToggle[],
                private campaignLoanOfficerConfigs: CampaignToggle[],
                private campaignService: CampaignService,
                private toastNotificationService: ToastNotificationService) {

    }

    changeCampaignStatus = (toggle: CampaignToggle) => {
        this.campaignService.updateCampaignConfiguration(toggle)
            .then(resp => {
                if (resp.status !== 200) {
                    this.toastNotificationService.generateErrorMessage(`Failed to switch toggle ${toggle.title}`)
                }
            });
    }
}
